import { createContext, useContext } from 'react'

export type SellerTourContextValue = {
  active: boolean
  startManual: () => void
  completeActivation: () => void
}

export const SellerTourContext = createContext<SellerTourContextValue | null>(null)

export function useSellerTour(): SellerTourContextValue | null {
  return useContext(SellerTourContext)
}
